import { DeepReadonlyObject } from 'rxdb';

import { DataChange, NormalizedScheduledLeg } from '@mopla/data-models';

import { closeSkippedBreaks } from '../legSequence';

export function mergeLegsWithChanges(
	legs: DeepReadonlyObject<NormalizedScheduledLeg>[],
	dataChanges: DeepReadonlyObject<DataChange>[]
): NormalizedScheduledLeg[] {
	const timeline: DeepReadonlyObject<NormalizedScheduledLeg>[] = legs
		.map((l) => {
			const updatedLeg = dataChanges
				.filter((ch) => ch.scheduledLegId === l.scheduledLegId)
				.sort((a, b) => b.insertTime - a.insertTime)[0];

			if (!updatedLeg) {
				return l;
			}

			const vehicleUpdates = updatedLeg.vehicleData
				? {
						checkDone: updatedLeg.checkDone,
						vehicleData: updatedLeg.vehicleData,
				  }
				: {};

			return {
				...vehicleUpdates,
				...l,
				state: updatedLeg.type,
			};
		})
		.sort((a, b) => {
			//TODO sorting can be applied once when saving original data to the collection
			const startDiff =
				new Date(a.start || '').getTime() - new Date(b.start || '').getTime();

			if (startDiff !== 0) {
				return startDiff;
			}

			/** Secondary sort by end time to keep stable order for legs with equal start times (e.g. very short trips) */
			return new Date(a.end || '').getTime() - new Date(b.end || '').getTime();
		});

	/** Breaks are closed before finished legs are dropped: a DONE leg is what closes the break before it */
	const result = closeSkippedBreaks(timeline).filter(
		(l) => l.state !== 'DONE' && l.state !== 'DONE_BREAK'
	);

	/** DeepReadonlyObject works only in the types layer, thus can be safely casted to a regular (mutable) type */
	return result as NormalizedScheduledLeg[];
}
